var resources = require('items-view-strings');
    var strings = resources['_oLSoHr0oZVFZh3pLik5bzg'];
export { strings };
export default strings;
